import {useEffect, useRef, useState} from 'react'
import {Modal, message} from 'antd'
import {Box, Text, Flex, Button, Image, useToast} from '@chakra-ui/react'
import Book from '@assets/svgs/learn/book.svg'
import Check from '@assets/svgs/learn/check.svg'
import Plus from '@assets/svgs/learn/plus.svg'
import CheckCircle from '@assets/svgs/learn/check_circle.svg'
import {useDispatch, useSelector} from 'react-redux'
import notebookRequest from '@apis/notebook'
import {
  updateIsOpenModalCreateFolder,
  updateIsOpenModalSaveKnowledge,
} from '@redux/notebook/notebookSlice'
import FormCreateFolder from './FormCreateFolder'
import {updateSavedPhrase} from '@redux/conversation/converstationSlice'
import {useLocation} from 'react-router-dom'
import Loading from '@components/Loading'

const FormSaveFolderModal = ({setSavedPhrase}: {setSavedPhrase: any}) => {
  const {typeSaveFolder, isOpenModalSaveKnowledge} = useSelector(
    (state: any) => state.notebook,
  )
  const {dataSavePhrase, savedPhrase} = useSelector(
    (state: any) => state.converstation,
  )
  const [folders, setFolders] = useState<any>()
  const [folderSelector, setFolderSelector] = useState<any>()
  const [isLoading, setIsLoading] = useState<any>(false)
  const [isLoadingFolders, setIsLoadingFolders] = useState<any>(false)
  const [recentlySaveFolder, setRecentlySaveFolder] = useState<any>()
  const [newFolder, setNewFolder] = useState<any>(null)
  const dispatch = useDispatch()
  const toast = useToast()
  const location = useLocation()
  const scrollRef = useRef<any>()
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    if (!isOpenModalSaveKnowledge) {
      return
    }

    getFolders()
  }, [typeSaveFolder, isOpenModalSaveKnowledge, newFolder])

  useEffect(() => {
    if (folders && isOpenModalSaveKnowledge) {
      setFolderSelector(folders[0])
      scrollRef.current?.scrollTo({
        top: 0,
        behavior: 'smooth', // This makes the scrolling smooth
      })
    }
  }, [folders, isOpenModalSaveKnowledge])

  useEffect(() => {
    if (!dataSavePhrase || !isOpenModalSaveKnowledge) {
      return
    }
    const params = dataSavePhrase
    if (!dataSavePhrase?.sentence || !dataSavePhrase?.phrase) return
    checkRecentlySavedFolder(params)
  }, [dataSavePhrase, isOpenModalSaveKnowledge])

  const getFolders = async () => {
    if (!typeSaveFolder) {
      return
    }
    setIsLoadingFolders(true)
    const params = {
      'lesson-id': location.state.lesson_id,
    }
    const res = await notebookRequest.getFolderSavePhrase(params)
    const dataNotebooks = [...res?.data?.data?.folders]
    if (newFolder) {
      if (newFolder && folders) {
        let index = dataNotebooks.findIndex(
          (item: any) => item.name === newFolder,
        )
        if (index > -1) {
          let element = dataNotebooks.splice(index, 1)[0]
          dataNotebooks.unshift(element)

          setFolders(dataNotebooks)
        }
      }
    } else {
      setFolders(dataNotebooks)
    }
    setIsLoadingFolders(false)
  }

  const checkRecentlySavedFolder = async (params: any) => {
    const res = await notebookRequest.checkRecentlySavedFolder(params)
    if (res?.status === 200) {
      setRecentlySaveFolder(res.data.data)
    } else {
      setRecentlySaveFolder(null)
    }
  }

  const handleCancelListFolderModal = () => {
    dispatch(updateIsOpenModalSaveKnowledge(false))
    if (newFolder) {
      setNewFolder(null)
    }
  }

  const handleSelectorFolder = (item: any) => {
    setFolderSelector(item)
  }

  const handleClickCreate = () => {
    dispatch(updateIsOpenModalCreateFolder(true))
  }

  const handleSave = async () => {
    setIsLoading(true)
    try {
      const params = {
        sentence: dataSavePhrase.sentence,
        phrase: dataSavePhrase.phrase,
        index: dataSavePhrase.index,
        folder_name: folderSelector?.name,
      }
      const res = await notebookRequest.savePhrase(params)
      if (res?.status === 200) {
        setSavedPhrase(true)
        if (newFolder) {
          setNewFolder(null)
        }
        if (savedPhrase) {
          const newSavePhrase = [...savedPhrase]
          savedPhrase.forEach((item: any, index: any) => {
            if (item.text_en === dataSavePhrase.phrase) {
              const newPhrase = {
                text_en: item.text_en,
                is_saved: true,
                folder_name: folderSelector?.name,
              }
              newSavePhrase[index] = newPhrase
              dispatch(updateSavedPhrase(newSavePhrase))
            }
          })
        }

        const idToast = toast({
          isClosable: true,
          position: 'bottom-left',
          duration: 7000,
          render: () => (
            <Box
              onClick={() => toast.close(idToast)}
              p={'24px'}
              bg="white"
              borderRadius={'16px'}
              boxShadow={
                '0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)'
              }>
              <Flex gap={'16px'} fontSize={'16px'} fontWeight={600}>
                <Image src={CheckCircle} />
                <Text>
                  Lưu thành công cụm từ vào sổ tay {folderSelector?.name || ''}
                </Text>
              </Flex>
            </Box>
          ),
        })
      }
      dispatch(updateIsOpenModalSaveKnowledge(false))
      setIsLoading(false)
      setRecentlySaveFolder(null)
    } catch (error) {
      setIsLoading(false)
      messageApi.error('Có lỗi xảy ra!')
    }
  }

  return (
    <>
      {contextHolder}
      <Modal
        title={
          <Text fontSize={'20px'} fontWeight={600}>
            Chọn mục để lưu
          </Text>
        }
        destroyOnClose={true}
        zIndex={1500}
        open={isOpenModalSaveKnowledge}
        width={400}
        footer={null}
        styles={{
          content: {borderRadius: '24px', padding: '28px'},
        }}
        onCancel={handleCancelListFolderModal}>
        {recentlySaveFolder && (
          <Text
            color={
              '#0050B3'
            }>{`Suỵt! Bạn đã lưu cụm này vào ${recentlySaveFolder.folder_name} rồi`}</Text>
        )}

        <Box
          className="scroll-bar"
          ref={scrollRef}
          mt={'16px'}
          borderRadius={'8px'}
          border={'1px solid #EAECF0'}
          h={'270px'}
          overflow={'auto'}
          overflowX={'hidden'}
          position={'relative'}>
          {isLoadingFolders && <Loading />}

          {folders?.map((item: any, index: any) => {
            return (
              <Flex
                key={index}
                gap={'12px'}
                alignItems={'center'}
                p={'8px 16px'}
                borderBottom={'1px solid #EAECF0'}
                cursor={'pointer'}
                onClick={() => handleSelectorFolder(item)}>
                <Flex
                  w={'44px'}
                  h={'44px'}
                  justifyContent={'center'}
                  alignItems={'center'}
                  borderRadius={'4px'}
                  bg={'#EFF8FF'}
                  flexShrink={0}>
                  <Image src={Book} />
                </Flex>
                <Flex flex={1} justifyContent={'space-between'}>
                  <Text className="line-clamp-1" fontSize={'16px'}>
                    {item.name}
                  </Text>
                  {folderSelector?.name === item.name && <Image src={Check} />}
                </Flex>
              </Flex>
            )
          })}
        </Box>
        <Flex justifyContent={'space-between'} mt={'16px'}>
          <Flex
            gap={'8px'}
            alignItems={'center'}
            cursor={'pointer'}
            onClick={handleClickCreate}>
            <Image src={Plus} />
            <Text fontSize={'16px'} fontWeight={700} color={'#2E90FA'}>
              Tạo mới
            </Text>
          </Flex>
          <Button
            isDisabled={isLoading}
            fontSize={'16px'}
            fontWeight={700}
            color={'white'}
            borderRadius={'12px'}
            bg={'#1890FF'}
            cursor={'pointer'}
            _hover={{
              bg: '#49a7ff',
            }}
            onClick={handleSave}>
            {!isLoading ? 'Lưu' : 'Đang lưu'}
          </Button>
        </Flex>
      </Modal>
      <FormCreateFolder getFolders={getFolders} setNewFolder={setNewFolder} />
    </>
  )
}

export default FormSaveFolderModal
